// models/Activity.js
export default class Activity {
    constructor({
        activityId = 0,
        activityType = "",
        isActive = false,
        establishmentsCount = 0
    } = {}) {
        this.activityId = activityId;
        this.activityType = activityType;
        this.isActive = isActive;
        this.establishmentsCount = establishmentsCount;
    }
}
